import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../mock';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#f8f4ec]/95 backdrop-blur border-b border-[#e5dcc9]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <span className="font-serif text-[26px] leading-none text-[#201d1a]">
            Trusted <span className="text-[#a4514a]">Hands</span>
            <span className="text-[#a4514a] text-[18px] align-super ml-1">NZ</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="label-caps text-[#3a342f] hover:text-[#a4514a] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#contact" className="hidden md:inline-flex btn-dark">
          Start a conversation
        </a>

        <button
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-[#201d1a]"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#f8f4ec] border-t border-[#e5dcc9] px-6 py-6">
          <div className="flex flex-col gap-5">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="label-caps text-[#3a342f]"
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn-dark w-fit">
              Start a conversation
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
